import React from 'react'
import { HiOutlineDotsVertical } from 'react-icons/hi'
import { IoMdArrowBack } from 'react-icons/io';
import { useNavigate } from 'react-router-dom'

export default function ChatRoomHeader({ userInfo, chatRoomData, setShowMenu, showMenu, menuRef, menuItems }) {
    const navigate = useNavigate();


    return (
        <div className="sticky top-0 z-50 h-12 bg-[#BDE6FF] rounded-b-xl flex w-full justify-center items-center flex-shrink-0">
            <div className="grid grid-cols-12 w-full items-center px-1 py-1.5">
                <div className="col-span-2 flex items-center justify-start">
                    <IoMdArrowBack
                        onClick={() => navigate("/message", { state: { activeTab: "Recent" } })}
                        className="text-[24px] text-black dark:text-black cursor-pointer"
                    />
                </div>

                <div className="col-span-8">
                    <div className="flex flex-col items-center justify-center gap-x-2">
                        <div className="flex items-center gap-x-2">
                            <img
                                alt="profile"
                                src={userInfo?.avatar_url || chatRoomData?.users?.[0]?.avatar_url}
                                onClick={() => navigate(`/account/${userInfo?.id || chatRoomData?.users?.[0]?.id}`)}
                                className="h-8 w-8 rounded-full object-cover cursor-pointer border border-gray-800 dark:border-gray-800"
                            />
                            <p
                                onClick={() => navigate(`/account/${userInfo?.id || chatRoomData?.users?.[0]?.id}`)}
                                className="text-[14px] font-semibold text-black dark:text-black cursor-pointer"
                            >
                                {userInfo?.full_name || chatRoomData?.users?.[0]?.full_name}
                            </p>
                        </div>
                        {/* Connection status indicator */}
                        {/* {isReconnecting && (
                                    <div className="flex items-center gap-x-1">
                                        <div className="w-2 h-2 bg-yellow-500 rounded-full animate-pulse"></div>
                                        <span className="text-[10px] text-yellow-500">Reconnecting...</span>
                                    </div>
                                )}
                                {!isConnected && !isReconnecting && (
                                    <div className="flex items-center gap-x-1">
                                        <div className="w-2 h-2 bg-red-500 rounded-full"></div>
                                        <span className="text-[10px] text-red-500">Disconnected</span>
                                    </div>
                                )} */}
                    </div>
                </div>

                <div className="col-span-2 flex items-center justify-end">
                    <HiOutlineDotsVertical
                        onClick={() => setShowMenu(!showMenu)}
                        className="text-[22px] text-black dark:text-black cursor-pointer"
                    />

                    {showMenu && (
                        <div
                            ref={menuRef}
                            className="absolute top-11 right-2 bg-white dark:bg-gray-900 border-2 border-indigo-100 rounded-lg shadow-lg w-fit overflow-hidden"
                        >
                            {menuItems.map((item, index) => (
                                <p
                                    key={index}
                                    onClick={item.action}
                                    className={`text-[12px] font-medium text-black dark:text-white hover:bg-gray-100 dark:hover:bg-gray-800 p-1.5 px-2 cursor-pointer 
                                                ${index === menuItems.length - 1 ? "" : "border-b border-gray-400 dark:border-gray-800"}`}
                                >
                                    {item.label}
                                </p>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}
